import styled, {keyframes,css} from 'styled-components';

type MobileSearchProps = {
    show: boolean;
}

const slideDown = keyframes`
    from {
        transform: translate(0, -100vh);
        visibility: hidden;
        opacity: 0;
    }
    to {
        transform: translate(0, 0);
        visibility: visible;
        opacity: 1;
    }
`;

const slideUp = keyframes`
    from {
        transform: translate(0, 0);
    }
    to {
        transform: translate(0, -100vh);
        visibility: hidden;
        opacity: 0;
    }
`;

const MobileSearchContainer = styled.div<MobileSearchProps>`
    /* display: ${props => props.show ? `block`: `none`}; */
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100vh;
    width: 100%;
    background-color: white;
    z-index: 100000001;
    animation: ${(props) =>
    props.show
        ? css`
            ${slideDown} .3s forwards 1
        `
        : css`
            ${slideUp} .5s forwards 1
        `};
    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        display: none;
        > * {
            display: none;
        }
    }

    @media print {
        display: none;
    }
`

const MobileSearchBar = styled.form`
    height: 8vh;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 5vw;
`

const MobileInputSearch = styled.input`
    flex-grow: 1;
    padding-left: 5vw;
    font-size: 0.9rem;
    outline: none;
    border: 0;
    :placeholder {
        color: #999999;
    }
`

const MobileSearchHistory = styled.section`
    display: flex;
    flex-direction: column;
    height: 92vh;
    background-color: #F3F3F4;
    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    
    li {
        padding: 2vh 0;
        font-size: 1.1rem;
        display: flex;
        align-items: center;

        > :first-child {
            padding: 0 5vw;
        }    
        span {
            color: #999999;
        }
    }
`

export { MobileInputSearch, MobileSearchBar, MobileSearchHistory, MobileSearchContainer }
